export default function(descriptor) {
  const { anyOf = [] } = descriptor;

  return {
    ...descriptor,
    anyOf: [...anyOf, { type: 'null' }],
  };
}
